var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", { staticClass: "title" }, [_vm._v("重开采购单")]),
      _c(
        "div",
        { staticClass: "leftContext" },
        [
          _c("div", { staticClass: "codeInfo" }, [
            _c("div", [
              _vm._v(" 采购编号："),
              _c("span", { staticStyle: { color: "#436ae8" } }, [
                _vm._v(_vm._s(_vm.table.oddNumber)),
              ]),
            ]),
            _c("div", [_vm._v("制单人：" + _vm._s(_vm.table.createdByName))]),
            _c("div", [
              _vm._v("制单时间：" + _vm._s(_vm.$moment(_vm.table.createdTime))),
            ]),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.table.goodsList } },
            [
              _c("el-table-column", {
                attrs: { label: "操作", type: "index", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.delBut(scope.$index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "序号", type: "index", width: "55" },
                on: { "row-click": function ($event) {} },
              }),
              _c("el-table-column", {
                attrs: { label: "图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.image
                          ? _c("img", {
                              staticStyle: { width: "50px", height: "50px" },
                              attrs: {
                                src:
                                  _vm.ImgHttps + scope.row.image.split(",")[0],
                                alt: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openDetails(scope.row)
                                },
                              },
                            })
                          : _c("span", [_vm._v("/")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "编号" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.code
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetails(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(scope.row.code))]
                            )
                          : _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetails(scope.row)
                                  },
                                },
                              },
                              [_vm._v("/")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品名称",
                  "show-overflow-tooltip": "",
                  "min-width": "120px;",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                scope.row
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.title))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.goodsType == 1
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetails(scope.row)
                                  },
                                },
                              },
                              [_vm._v("商品")]
                            )
                          : _c(
                              "span",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.openDetails(scope.row)
                                  },
                                },
                              },
                              [_vm._v("赠品")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "品牌" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.brandName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "分类" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.typeName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.sellPrice))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "规格" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.specificationName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "实际库存" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.quantityStock))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "right" }, [
      _c("div", { staticClass: "title" }, [_vm._v("操作")]),
      _c(
        "div",
        { staticClass: "rightContext", staticStyle: { border: "0" } },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
            [
              _c("el-form-item", { attrs: { label: "采购部门" } }, [
                _c(
                  "div",
                  { staticClass: "selectTree" },
                  [
                    _c("treeselect", {
                      attrs: {
                        options: _vm.options,
                        "search-nested": "",
                        normalizer: _vm.normalizer,
                        noResultsText: "未找到",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.form.bumenCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "bumenCode", $$v)
                        },
                        expression: "form.bumenCode",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "供应商" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入供应商名称",
                      value: _vm.form.supplierName,
                      supplierName: "",
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购类型" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购类型",
                      value: _vm.form.goodsType == 1 ? "商品" : "赠品",
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购商品" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购商品",
                      value: _vm.form.title,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购规格" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购规格",
                      value: _vm.form.specificationName,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购品牌" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购品牌",
                      value: _vm.form.brandName,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购金额" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购金额",
                      value: _vm.form.sellPrice * _vm.form.numberTotal,
                      disabled: "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "采购数量" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入采购数量",
                      disabled: "",
                      value: _vm.form.numberTotal,
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "入库仓库" } },
                [
                  _vm._l(_vm.form.selectObj, function (ite, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                          "align-items": "center",
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              value: ite.warName,
                              size: "mini",
                              "value-key": "id",
                              placeholder: "请选择",
                              disabled: ite.goodsType == 0,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.myWareListChange($event, ite)
                              },
                            },
                          },
                          _vm._l(_vm.wareList.list, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item },
                            })
                          }),
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                            },
                          },
                          [
                            _c("el-input-number", {
                              staticStyle: { "margin-right": "10px" },
                              attrs: {
                                size: "mini",
                                min: 0,
                                placeholder: "请输入库存数量",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.inputChange(ite)
                                },
                              },
                              model: {
                                value: ite.number,
                                callback: function ($$v) {
                                  _vm.$set(ite, "number", $$v)
                                },
                                expression: "ite.number",
                              },
                            }),
                            _c("i", {
                              staticClass: "el-icon-remove-outline",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  return _vm.deleteMyWare(
                                    ite,
                                    ite.goodsType != undefined ? 1 : 0
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c("i", {
                    staticClass: "el-icon-circle-plus-outline",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.addMyWareList()
                      },
                    },
                  }),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "上传图片" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "video",
                      attrs: {
                        action: "#",
                        multiple: "",
                        "before-upload": _vm.beforeUploadImg,
                        "http-request": _vm.imgUpload,
                        "show-file-list": false,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { type: "primary", size: "mini" } },
                        [_vm._v("选择图片")]
                      ),
                    ],
                    1
                  ),
                  _vm._l(_vm.form.fileListImg, function (itemsImg, index) {
                    return _vm.form.fileListImg
                      ? _c("div", { key: index, staticClass: "liimg" }, [
                          itemsImg
                            ? _c("img", {
                                directives: [
                                  {
                                    name: "image-preview",
                                    rawName: "v-image-preview",
                                  },
                                ],
                                staticClass: "img-avatar",
                                attrs: { src: _vm.ImgHttps + itemsImg.img },
                              })
                            : _vm._e(),
                          itemsImg
                            ? _c(
                                "p",
                                {
                                  staticClass: "close",
                                  on: {
                                    click: function ($event) {
                                      return _vm.delectImgList(index)
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-error" })]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e()
                  }),
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "备注" } },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "255",
                      placeholder: "请输入备注",
                      type: "textarea",
                    },
                    model: {
                      value: _vm.textarea,
                      callback: function ($$v) {
                        _vm.textarea = $$v
                      },
                      expression: "textarea",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "p",
            { staticStyle: { "text-align": "right", "margin-top": "50px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.submit },
                },
                [_vm._v("确认")]
              ),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.cancel } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }